import { MessageContext } from "../context/MessageContext";
import { useContext } from "react";

export const useMessageContext = () => {
    const context = useContext(MessageContext);

    if (!context) {
        return Error('useMessageContext must be used inside an MessageContextProvider');
    };

    return context;
};